import React, { Fragment } from "react";
import { lazyWithRetry } from "../../core/lazy_with_retry";

import { useI18n } from "../../lib/i18n/i18n_provider";
import { TemplateOfferingDetailsMeetingRoom } from "../template_offering_details_meeting_room";
import { useWeWorkAnalytics } from "./wework_analytics";
import {
  faqsMeetingRoomEN,
  faqsMeetingRoomHE,
  generalInfoEN,
  generalInfoHE,
  useWeWorkPartnerConfig,
} from "./wework_partner_config";

const Theme = lazyWithRetry(() => import("./wework_theme"));

const descriptionEN =
  "Book a premium Classroom at WeWork location. Whether you need a space for classes, off-sites, or just looking for a private space for working productively - we’ve got you covered. Reserve a room in advance, check-in, and get to work.";
const descriptionHE =
  "שריינו כיתות בסטנדרט הבינלאומי של-WeWork. בין אם אתם צריכים חלל עבור הדרכות, העברת קורס, פעילות גיבוש או סתם חלל פרטי לעבודה פרודוקטיבית, אנחנו כאן בדיוק בשביל זה. איך זה עובד? מזמינים חדר ישיבות, מגיעים ביום ההזמנה לצ'ק אין זריז עם הצוות שלנו בדלפק הקבלה וניגשים לעניינים.";
export function OfferingWeWorkClassroom() {
  const { locale } = useI18n();
  const partnerConfig = useWeWorkPartnerConfig();
  useWeWorkAnalytics();
  return (
    <Fragment>
      <Theme />
      <TemplateOfferingDetailsMeetingRoom
        showAddress
        showDirections
        firstDayOfWeek={0}
        partnerConfig={partnerConfig}
        data={{
          description:
            locale.baseLanguageTag === "en" ? descriptionEN : descriptionHE,
          faqs:
            locale.baseLanguageTag === "en"
              ? faqsMeetingRoomEN
              : faqsMeetingRoomHE,
          generalInfo:
            locale.baseLanguageTag === "en" ? generalInfoEN : generalInfoHE,
        }}
        getDesktopImages={(spaceImages) => spaceImages.map((i) => i.medium)}
        getModalImages={(spaceImages) => spaceImages.map((i) => i.large)}
        getMobileImages={(spaceImages) => spaceImages.map((i) => i.small)}
      />
    </Fragment>
  );
}
